'use client';

type TabType = 'pre' | 'post';

interface EventTabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  isPostTabDisabled?: boolean;
  disabledMessage?: string;
}

export default function EventTabNavigation({ activeTab, onTabChange, isPostTabDisabled = false, disabledMessage = 'Create the event first' }: EventTabNavigationProps) {
  return (
    <div className="flex gap-4 sm:gap-6 lg:gap-8 border-b border-gray-200 mb-6 sm:mb-8">
      <button className={`px-3 sm:px-4 lg:px-5 py-1.5 sm:py-2 text-sm sm:text-base ${activeTab === 'pre' ? 'text-[#5167b2] border-b-4 border-[#5167b2] font-bold' : 'text-gray-400 hover:text-[#5167b2] font-semibold'} bg-transparent rounded-t-xl focus:outline-none cursor-pointer`} onClick={() => onTabChange('pre')}>
        Pre Event
      </button>
      <button className={`px-3 sm:px-4 lg:px-5 py-1.5 sm:py-2 text-sm sm:text-base ${activeTab === 'post' ? 'text-[#5167b2] border-b-4 border-[#5167b2] font-bold' : 'text-gray-400 hover:text-[#5167b2] font-semibold'} bg-transparent rounded-t-xl focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer`} onClick={() => onTabChange('post')} disabled={isPostTabDisabled} title={isPostTabDisabled ? disabledMessage : ''}>
        Event Questions
      </button>
    </div>
  );
}
